import { z } from "zod/v4";
import { DateUtils } from "../../../primitive-utils";
import { REGEX_LOCAL_YEAR } from "../base/time-regex";
import { YearSchema as InnerYearSchema } from "../base/time-schema";
/** 年を表す。 */
const YearSchema = InnerYearSchema.brand("Year");
// ** Year <-> Date 変換系 ** //
/** DateをJST解釈のYearに変換 */
const fromDateJST = (v) => {
    const jstDate = DateUtils.utcToJSTTime(v);
    return fromDate(jstDate);
};
/** private. TZは実行環境に依存する */
const fromDate = (d) => {
    return Year.of({
        year: d.getFullYear(),
    });
};
// ** Year <-> string 変換系 ** //
/**
 * 2020, 2020年 などの形式のYearを扱うえるようにするスキーマ
 */
const YearStringSchema = z
    .string()
    .regex(REGEX_LOCAL_YEAR, { message: "年の形式が不正です。" })
    .transform((val) => {
    const extractRegex = /\d+/g; // 数字を抽出
    const [year] = val.match(extractRegex)?.map(Number) ?? [];
    return { year };
});
/** 形式チェックのみで、厳密な日付存在チェックを経ないparse */
const parseSoft = (v) => {
    return YearStringSchema.parse(v);
};
/** string => Year */
const parse = (v) => {
    return Year.schema.parse(parseSoft(v));
};
/**
 * firstYearからlastYearまでの年をリストで取得する。
 */
const getRange = (firstYear, lastYear) => {
    return Array.from({ length: lastYear.year - firstYear.year + 1 }, (_, i) => Year.of({ year: firstYear.year + i }));
};
export const Year = {
    schema: YearSchema,
    stringSchema: YearStringSchema,
    parseSoft,
    parse,
    THIS_YEAR: () => fromDateJST(new Date()),
    of(args) {
        return Year.schema.parse(args);
    },
    getRange,
};
//# sourceMappingURL=year.js.map